

export default {
    name: "HeroSlider",
    props: {
        blok: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            currentSlide: 0,
            touchStartX: 0,
            touchEndX: 0,
            autoSlideInterval: null,
        }
    },
    mounted() {
        this.startAutoSlide()
    },
    beforeDestroy() {
        this.stopAutoSlide()
    },
    methods: {
        startAutoSlide() {
            if (this.blok?.slides.length > 1) {
                this.autoSlideInterval = setInterval(() => {
                    this.nextSlide()
                }, 8000) 
            }
        },
        stopAutoSlide() {
            if (this.autoSlideInterval) {
                clearInterval(this.autoSlideInterval)
                this.autoSlideInterval = null
            }
        },
        goToSlide(index) {
            this.stopAutoSlide()
            this.currentSlide = index
            this.startAutoSlide()
        },
        nextSlide() {
            this.currentSlide =
                (this.currentSlide + 1) % this.blok?.slides.length
        },
        prevSlide() {
            this.currentSlide =
                (this.currentSlide - 1 + this.blok?.slides?.length) % this.blok?.slides?.length
        },
        onTouchStart(event) {
            this.stopAutoSlide()
            this.touchStartX = event.touches[0].clientX
        },
        onTouchMove(event) {
            this.touchEndX = event.touches[0].clientX
        },
        onTouchEnd() {
            const deltaX = this.touchStartX - this.touchEndX
            const threshold = 50
            if (deltaX > threshold) {
                this.nextSlide()
            } else if (deltaX < -threshold) {
                this.prevSlide()
            }
            this.startAutoSlide()
        },
    },
}
